(function () {
  if (!('IntersectionObserver' in window)) return;

  /* ── Estilos injectados dinamicamente ── */
  var style = document.createElement('style');
  style.textContent = [
    '[data-nv-reveal] {',
    '  opacity: 0;',
    '  transform: translateY(28px);',
    '  transition: opacity 1.1s cubic-bezier(0.25, 0.46, 0.45, 0.94),',
    '              transform 1.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);',
    '  will-change: opacity, transform;',
    '}',
    '[data-nv-reveal].nv-revealed {',
    '  opacity: 1;',
    '  transform: none;',
    '}',
    '@media (prefers-reduced-motion: reduce) {',
    '  [data-nv-reveal] { opacity: 1; transform: none; transition: none; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  /* ── Observer ── */
  /* threshold: 0 — dispara assim que qualquer pixel da secção entra no viewport.
     Necessário para secções altas no mobile (Zone 2 com 10+ blocos pode ter
     10 000 px de altura; um threshold de 12% nunca seria atingido num viewport
     de 700 px). O rootMargin -60px já fornece o buffer visual necessário. */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('nv-revealed');
      io.unobserve(entry.target);
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px -60px 0px'
  });

  function revealEl(el, delay) {
    el.setAttribute('data-nv-reveal', '');
    if (delay) el.style.transitionDelay = delay + 'ms';
    io.observe(el);
  }

  /* ── Init: per-block onde existir [data-nv-block], fallback para a secção ── */
  function init() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (sec, i) {
      if (i === 0) return; /* hero acima da dobra */

      var blocks = sec.querySelectorAll('[data-nv-block]');
      if (blocks.length > 0) {
        blocks.forEach(function (block, idx) {
          revealEl(block, idx * 130);
        });
      } else {
        revealEl(sec, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();